export default __webpack_public_path__ + "static/7-34aab34b023332f17ffca7182bdd3e42.png";